import React from 'react';
import Heading from 'app_previous/elements/typography/heading';
import Paragraph from 'app_previous/elements/typography/paragraph';
import { palette } from 'app_previous/styles/colors';
import {
  TemplateHero,
  TemplateTitle,
  TemplateTitleImageLayout,
  TemplateTitleImage,
  TemplateTitleText,
  TemplateTitleBackground,
  TemplateTitleBackgroundImage,
  TemplateTitleMetadata,
  TemplateTitleCategoryChip,
} from './ResourceHeroBanner.styles';
import { GatsbyImage, IGatsbyImageData } from 'gatsby-plugin-image';

interface ResourceHeroBannerProps {
  titleImage: IGatsbyImageData;
  category: string;
  title: string;
  description?: string;
  author: string;
  updatedAt: string;
  readTime?: string;
}

const ResourceHeroBanner = ({
  titleImage,
  category,
  title,
  description,
  author,
  updatedAt,
  readTime,
}: ResourceHeroBannerProps): JSX.Element => {
  return (
    <TemplateHero>
      <TemplateTitleBackground />
      <TemplateTitleBackgroundImage>
        <GatsbyImage
          image={titleImage}
          alt=''
        />
      </TemplateTitleBackgroundImage>
      <TemplateTitle>
        <TemplateTitleImageLayout>
          <TemplateTitleImage>
            <GatsbyImage
              image={titleImage}
              alt=''
            />
          </TemplateTitleImage>
        </TemplateTitleImageLayout>
        <TemplateTitleText>
          <TemplateTitleCategoryChip>{category}</TemplateTitleCategoryChip>
          <Heading
            text={title}
            standardSize='3.375'
            align='left'
            color='white'
          />
          <Paragraph
            text={description || ''}
            standardSize='1.5'
            weight='light'
            lineHeight='1.5'
            align='left'
            color={palette.white}
          />
          <TemplateTitleMetadata>
            <Paragraph
              className='author'
              text={`By ${author}`}
              standardSize='1'
              weight='light'
              lineHeight='1.5'
              align='left'
              color={palette.white}
            />
            <Paragraph
              className='date'
              text={updatedAt || ''}
              standardSize='1'
              weight='light'
              lineHeight='1.5'
              align='left'
              color={palette.white}
            />
            {readTime && (
              <Paragraph
                className='read-time'
                standardSize='1'
                text={`${readTime} read`}
                weight='light'
                lineHeight='1.5'
                align='left'
                color={palette.white}
              />
            )}
          </TemplateTitleMetadata>
        </TemplateTitleText>
      </TemplateTitle>
    </TemplateHero>
  );
};

export default ResourceHeroBanner;
